mutation packageWithLinksCrud(
  $scenarioId: ID!
  $originId: ID!
  $input: PackageWithLinksInput!
) {
  cube(scenarioId: $scenarioId, originId: $originId) {
    packageWithLinksCrud(input: $input) {
      skippedValidations
      commited
      userCanSkipValidations
      payload {
        package {
          package {
            id
            code
            index
          }
          validationErrors {
            ...PackageWithLinksValidation
          }
        }
        links {
          link {
            id
            code
            course {
              id
              code
              name
            }
          }
          validationErrors {
            ...PackageWithLinksValidation
          }
        }
      }
    }
  }
}

fragment PackageWithLinksValidation on EditorValidationError {
  __typename
  ... on GenericInvalidValidation {
    allowed
    reason
  }
  ... on CanEditPackages {
    allowed
    reason
  }
  ... on InvalidLinksCourse {
    allowed
    reason
  }
  ... on InvalidLinksPackage {
    allowed
    reason
  }
  ... on InvalidGroupCodeValidation {
    allowed
    reason
    rejected_groups {
      id
      code
      capacity
    }
  }
  ... on InvalidFieldValidation {
    value
    reason
    meta
  }
  ... on InvalidSectionChanges {
    validationErrors {
      __typename
      ... on InvalidInput {
        code
        meta
      }
      ... on InvalidComponentSize {
        reason
        capacity
        component {
          id
        }
      }
    }
  }
}
